module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Gysc3K/tc-custom/9781504093675.jpg?1731180728693",
      "alt": "This image is the cover for the book What Lies in the Dark"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("What Lies in the Dark\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Suspicion and paranoia engulf a community while a police detective hunts for a serial killer.")]), _c('br'), _c('br'), _vm._v(" One murder can make a town nervous. Two brings fear. Add three, four, or even more, and neighbors will start to turn on one another . . ."), _c('br'), _c('br'), _vm._v(" Victoria Bullrush is a stickler for rules and tries to maintain a faultless investigation. But with each grisly killing, the urgency grows greater, and it soon becomes impossible to ignore the public’s growing anger . . ."), _c('br'), _c('br'), _vm._v(" Who is behind the killings? And why are they targeting this community?"), _c('br'), _c('br'), _c('i', [_vm._v("What Lies in the Dark")]), _vm._v(" is a breathtaking debut crime thriller.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      CM Thompson\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0